const AIDesk = {
  "结束会话": "End Conversation",
  "转人工服务": "Agent Transfer",
  "跳转": "Open",
  "立即填写": "Fill now",
  "已提交": "Submitted",
  "提交": "Submit",
  "查看内容": "View content",
  "请填写必填项": "Please fill in the required fields",
  "请输入内容":"Please enter the content",
  "如果满意请给好评哦～":"If you're satisfied, please give a good review~",
  "请对本次服务进行评价": "Please rate this service",
  "提交评价": "Service Rating",
  "并发限制": "There are currently too many users accessing the service. Please try again later",
  "分支选项异常": "Content is abnormal, please check the task flow configuration",
  "服务评价": "Service Rating",
  "满意": "Satisfied",
  "不满意": "Dissatisfied",
  "感谢您的反馈，我们会持续优化改进": "Thank you for your feedback, we will continue to improve",
  "您遇到了哪方面的问题": "What problem did you encounter",
  "其他反馈内容": "Other feedback",
  "取消": "Cancel",
  "答非所问": "Irrelevant answer",
  "未匹配相关内容": "No relevant content matched",
  "信息错误": "Incorrect information",
  "上下文理解错误": "Context misunderstanding",
  "格式不规范": "Improper format",
  "内容不完整": "Incomplete content",
  "file 大小超过 100MB，无法发送": "Unable to send the file as it exceeds 100 MB",
  "image 大小超过 20MB，无法发送": "Unable to send the image as it exceeds 20 MB",
  "video 大小超过 100MB，无法发送": "Unable to send the video as it exceeds 100 MB",
  "提交成功": "Submitted successfully",
  "userID 只能包含可打印 ASCII 字符": "The userID can only contain printable ASCII characters",
  "userID 不能包含'administrator'": "The userID cannot contain the string 'administrator'",
  "userID 长度不能超过45字节": "The length of the userID cannot exceed 45 bytes",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "We appreciate your feedback. Please share any suggestions to help us improve.",
  "该回复由AI生成，内容仅供参考": "AI-Generated Content",
  "排队等待中": "In Queue",
  "排队等待话术": "We apologize for the wait. All agents are currently assisting other customers. You will be connected shortly. Thank you for your patience.",
  "当前前方排队人数": "Queue Position",
  "结束排队": "Leave Queue",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "Once a review has been submitted for more than 3 minutes, it cannot be modified.",
  "不能发送空白消息": "Unable to send blank message",
  "确认转人工": "Confirm transfer to agent",
}
export default AIDesk;
